import { BranchConfig } from "../../../components/pages";
import EditBranch from "../Branches/Branch/Edit";
import Settings from "./index"
export const paths = [
    {
        path: "/settings",
        component: Settings
    }
    ,
    {
        path: "/settings/branch",
        component: BranchConfig
    },
    {
        path: "/settings/branch2",
        component: EditBranch
    }
]

export const SettingsRouters = {
    icon: "cog",
    testId: '',
    path: "/settings",
    label: "Configurações",
    tree: []
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Settings/routers.js